import { createBrowserRouter, type RouteObject } from "react-router-dom";
import { Layout } from "./components/Layout.js";
import { AlertsScreen } from "./screens/AlertsScreen.js";
import { SubscriptionScreen } from "./screens/SubscriptionScreen.js";
import { AlertFormScreen } from "./screens/AlertFormScreen.js";
import { StatsScreen } from "./screens/StatsScreen.js";
import { TermsScreen } from "./screens/TermsScreen.js";
import { PrivacyScreen } from "./screens/PrivacyScreen.js";
import { NotFoundScreen } from "./screens/NotFoundScreen.js";

export const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <AlertsScreen />,
      },
      {
        path: "subscription",
        element: <SubscriptionScreen />,
      },
      {
        path: "alert/new",
        element: <AlertFormScreen />,
      },
      {
        path: "alert/:id",
        element: <AlertFormScreen />,
      },
      {
        path: "stats",
        element: <StatsScreen />,
      },
      {
        path: "terms",
        element: <TermsScreen />,
      },
      {
        path: "privacy",
        element: <PrivacyScreen />,
      },
      {
        path: "*",
        element: <NotFoundScreen />,
      },
    ],
  },
];

export const router = createBrowserRouter(routes);
